module.exports = __webpack_public_path__ + "static/media/handlebars.38dd7251.png";